import React from 'react';
import authHeader from '../../services/auth-header';
import './index.css';
import AuthService from '../../services/auth.service';
import i18n from 'i18next';
import ConfigItemComponent from './ConfigItemComponent';



export default class ConfigsListComponent extends React.Component{
    
    constructor(props){
        super(props);

        this.state = {
        }

        this.getList()
    }


    getList(){

        AuthService.getConfigsList(authHeader).then(

            response => {
                
                const configs = response.data;
                
                const items = configs.map(
                    data => {
                        return <ConfigItemComponent data={data} />
                    }
                ) 

                this.setState({items:items})

            }
        )

    }

    render(){
        
        return(
            <div className='index-list-container'>
                <a href='/add-config' className='add-parser-page-btn'>{i18n.t("new_config")}</a>
                <div className='index-list-header'>

                    <p style={{width:"20%"}}>Key</p>
                    <p style={{width:"80%"}}>Value</p>

                </div>

                {this.state.items}

            </div>
        );
        
    }
}